import { v4 as uuidv4 } from 'uuid';
const defaultIconProps = {
	size: 16,
	viewBox: '0 0 16 16',
	isActive: true,
	mutedClassName: '',
	activeClassName: '',
};
//spread para clonar e nao substituir o defaulticon
export const Icon = (props = {}) => {
	return {
		componentName: 'Icon',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconCart = (props = {}) => {
	return {
		componentName: 'IconCart',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconCaret = (props = {}) => {
	return {
		componentName: 'IconCaret',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconClose = (props = {}) => {
	return {
		componentName: 'IconClose',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconDelete = (props = {}) => {
	return {
		componentName: 'IconDelete',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconExpand = (props = {}) => {
	return {
		componentName: 'IconExpand',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconPause = (props = {}) => {
	return {
		componentName: 'IconPause',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconPlay = (props = {}) => {
	return {
		componentName: 'IconPlay',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconVolumeOn = (props = {}) => {
	return {
		componentName: 'IconVolumeOn',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconVolumeOff = (props = {}) => {
	return {
		componentName: 'IconVolumeOff',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
export const IconMenu = (props = {}) => {
	return {
		componentName: 'IconMenu',
		componentId: uuidv4(),
		props: Object.assign({ ...defaultIconProps }, props),
	};
};
